import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

export interface DeskItem {
    id: string;
    title: string;
    selectable: boolean;
    initials?: string;
}

@Component({
    selector: 'st-topic-button',
    imports: [MatButton, MatIcon, MatTooltip],
    templateUrl: './topic-button.html',
    styleUrl: './topic-button.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-topic-button',
    },
})
export class TopicButtonComponent extends EnpsControlComponent<string> {
    readonly inFullScreenMode = input(false, {
        transform: coerceBooleanProperty,
    });

    readonly topicOpenEmitter = output();
}
